export const panagramsArr = [
  'The five boxing wizards jump quickly',
  'The quick brown fox jumps over a lazy dog',
  'Pack my box with five dozen liquor jugs',
  'We promptly judged antique ivory buckles for the next prize',
  'Sixty zippers were quickly picked from the woven jute bag',
  'Crazy Fredrick bought many very exquisite opal jewels',
  'Jump by vow of quick, lazy strength in Oxford',
  'Sphinx of black quartz: judge my vow',
  'Five big quacking zephyrs jolt my wax bed',
  'Jim just quit and packed extra bags for Liz Owen',
  'A large fawn jumped quickly over white zinc boxes',
  'Viewing quizzical abstracts mixed up hefty jocks',
  'Five or six big jet planes zoomed quickly by the tower',
  'Six big devils from Japan quickly forgot how to waltz',
  'My grandfather picks up quartz and valuable onyx jewels',
  'Jeb quickly drove a few extra miles on the glazed pavement',
  'Grumpy wizards make toxic brew for the evil Queen and Jack',
]

export const textPalettes = [
  {
    "background": "#491700",
    "color": "#F47D3B"
  },
  {
    "background": "#005329",
    "color": "#FBDD4F"
  },
  {
    "background": "#D1DEF1",
    "color": "#0B1839"
  },
  {
    "background": "#F8F1DF",
    "color": "#EF381D"
  },
  {
    "background": "#F2F2F2",
    "color": "#107055"
  },
  {
    "background": "#252525",
    "color": "#ABC6DB"
  },
  {
    "background": "#BE3B33",
    "color": "#ECEDE8"
  },
  {
    "background": "#E5B8B5",
    "color": "#1F1A14"
  },
  {
    "background": "#02FECB",
    "color": "#F77784"
  },
  {
    "background": "#F5FCF4",
    "color": "#181415"
  },
  {
    "background": "#5C9BEB",
    "color": "#F5AFAA"
  },
  {
    "background": "#DD042F",
    "color": "#4335FA"
  },
  {
    "background": "#C9CDE8",
    "color": "#F67C67"
  },
  {
    "background": "#C2EADF",
    "color": "#1F96A5"
  },
  {
    "background": "#161B1E",
    "color": "#00CDC1",
  },
  {
    "background": "#1F3E91",
    "color": "#EDF9FC",
  },
  {
    "background": "#EEEEEE",
    "color": "#A2CDB1",
  },
  {
    "background": "#42475B",
    "color": "#E6E1E7",
  },
  {
    "background": "#F7A901",
    "color": "#E6EBD3",
  }
]

export const textBorderPalettes = [
  {
    "background": "#43C3D0",
    "color": "#FDDB33",
    "border": "#0F4E59"
  },
  {
    "background": "#EEBE06",
    "color": "#DCDDDF",
    "border": "#080F1D"
  },
  {
    "background": "#83D0CA",
    "color": "#CF4E48",
    "border": "#E8C248"
  },
  {
    "background": "#EF5B7F",
    "color": "#DFCC54",
    "border": "#090103"
  },
  {
    "background": "#FCB5BB",
    "color": "#F8ECDC",
    "border": "#193950"
  },
  {
    "background": "#FCEBC0",
    "color": "#FFD02F",
    "border": "#AE298C"
  },
  {
    "background": "#FF9595",
    "color": "#FDFCFE",
    "border": "#853636"
  },
  {
    "background": "#2DBEC3",
    "color": "#F6F2D6",
    "border": "#201C2A"
  },
  {
    "background": "#F2EF6E",
    "color": "#75BFE6",
    "border": "#FFFCEA"
  },
  {
    "background": "#B2A59C",
    "color": "#C6765A",
    "border": "#245D71"
  },
  {
    "background": "#89CBBD",
    "color": "#E796B9",
    "border": "#F4F3F6"
  },
  {
    "background": "#BDE7E6",
    "color": "#F96C3E",
    "border": "#FEFBF2"
  },


]



// WEBPACK FOOTER //
// ./src/components/generator/constants/Panagrams.js